<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="errorMessage" :mensagem="errorMessage" />


    <div v-if="!modoVisualizacao">
        <div class="form-edit-page row-space">
            <div class="row">
                <div class="form-item-rangedata"><DateRangeSelect :periodoInicial="'currentMonth'" v-model="dateRange" /></div>
                <IpOsSolicitacaoStatusSelect class="form-item" v-model:statusSelecionado="statusSelecionado" />                
                <button type="button" class="buttom-icon--search" @click="lerDados" />
                <button type="button" class="buttom-icon--printer" @click="imprimir" />
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>

        
        <div v-if="lsDados.length>0" class="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th class="col-width-char10">Solicitação</th>
                        <th class="col-width-char10">Data</th>
                        <th class="col-width-char30">Bairro</th>
                        <th>Serviço</th>
                        <th class="col-width-char30">Situação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"  @click="setVisualizar(obj)">
                        <td class="col-width-char10 right">{{ obj.cdipossolicitacao }}</td>
                        <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtsolicitacao) }}</td>
                        <td class="col-width-char30">{{ obj.nmbairro }}</td>
                        <td>{{ obj.nmipservico }}</td>
                        <td class="col-width-char30">{{ obj.statusnm }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-if="modoVisualizacao">
        <IpOSSolicitacaoViewPage :idView="idView" @close="modoVisualizacao = false" @save="lerDados" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost, genericReport } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import IpOsSolicitacaoStatusSelect from '@/selects/IpOsSolicitacaoStatusSelect.vue';
import IpOSSolicitacaoViewPage from '../cadastros/visualizacoes/IpOSSolicitacaoViewPage.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const errorMessage = ref(null);
const idView = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoVisualizacao = ref(false);
const statusSelecionado = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closeForm = () => {emit('close');}

const imprimir = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        errorMessage.value = null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: 'ipossolicitacoes',
            idmunicipio: globalStore.idmunicipio,
            idusuario: globalStore.idusuario,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate,
            intp1: statusSelecionado.value};
        const response = await genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){errorMessage.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}

const lerDados = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        errorMessage.value = null;
        isLoading.value = true;
        const req = await genericPost('/ip/ipossolicitacoes', {
            idmunicipio: globalStore.idmunicipio,
            datainicial: dateRange.value.startDate, 
            datafinal:dateRange.value.endDate,
            intparam1: statusSelecionado.value});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){errorMessage.value =`ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}

const setVisualizar = (obj) =>{
    idView.value = obj.id;
    modoVisualizacao.value = true;
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>
